﻿import React, { useState, useEffect } from 'react';
import { LookupItem } from '../models/lookup-item';

import TextBox, { TextBoxTypes } from 'devextreme-react/text-box';
import List from 'devextreme-react/list';
import { Button } from 'devextreme-react/button';

export interface Props {
    sampleName?: string;
    samplePreparationTypes?: LookupItem[];
    onApplySelection?: (sampleName: string) => void;
    onCancel?: () => void;
}

export default function SampleNameEntry(props: Props) {

    const [dataLoaded, setDataLoaded] =
        useState<boolean>(false);

    const [sampleName, setSampleName] =
        useState<string>(props.sampleName);

    const [validationText, setValidationText] =
        useState<string>();

    const [sampleTypes, setSampleTypes] =
        useState<string[]>();

    useEffect(() => {
        console.log("useEffect[]");
        createSampleTypeList();
    }, []);

    useEffect(() => {
        console.log("useEffect[sampleName]");
        validateSampleName();
        // setAuthorizations();
    }, [sampleName]);


    return (
        <div className="pw-stacked-components-100">
            <div className="pw-grow pw-40-60-column-grid">
                <div>
                    <div className="pw-form-unit">
                        <label className="textbox-label">Sample Name</label>
                        <TextBox id="sampleNameTextBox" className="textbox"
                            onValueChanged={sampleNameChanged}
                            showClearButton={true}
                            placeholder="sample name" value={sampleName ? sampleName : undefined} />
                    </div>
                    <div className="pw-form-unit-label">{validationText}</div>
                </div>
                <div className="pw-bordered-pane">
                    <label className="textbox-label">Sample Preparation Types</label>
                    <List height="28rem" 
                        pageLoadMode="scrollBottom"
                        searchExpr="name"
                        searchEnabled={true}
                        searchMode="contains"
                        onItemClick={onSamplePreparationTypesListItemClick}
                        itemRender={renderSamplePreparationType}
                        dataSource={props.samplePreparationTypes ?
                            props.samplePreparationTypes : []} />
                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-centered-buttons-container">
                    <Button id="applySelectionButton"
                        className="pw-button"
                        text="Apply" type="success"
                        hint="apply selection"
                        height={'2.6em'}
                        onClick={onApplyClick} />

                    <Button id="cancelButton"
                        className="pw-button"
                        text="Cancel" type="normal"
                        hint="cancel"
                        height={'2.6em'}
                        onClick={onCancelClick} />
                </div>
            </div>
        </div>

    );

    function onSamplePreparationTypesListItemClick(e: any) {
        //console.log("onSamplePreparationTypesListItemClick");
        //console.log(e);

        if (e.itemData && e.itemData.name)
            setSampleName(e.itemData.name);
    }

    function sampleNameChanged(e: TextBoxTypes.ValueChangedEvent) {
        setSampleName(e.value);
    }

    function getSampleNameValidation() {
        //change the class here:
        return <div className="pw-form-unit-label">Is Valid</div>;        
    }

    function validateSampleName() {
        if (!sampleTypes)
            return;
            
        if (sampleName) {
            let resultInfo = "Entry valid";
            let formCorrect = false;
            let sampleNameOnly = '';

            let reg = sampleName.search(/^[a-zA-Z]+\s*\d*\s*([-]\s*\d+){0,2}$/);

            if (reg > -1) {
                formCorrect = true;

                const name = /^([a-zA-Z]+)\s*/i.exec(sampleName);

                if (name && name.length > 0) {
                    sampleNameOnly = name[0].trim();
                }            
            }

            if (!formCorrect) {
                resultInfo = "Form invalid";
            }
            else if (!sampleTypes.includes(sampleNameOnly)) {
                resultInfo = `${sampleNameOnly} not found in valid Sample Names`
            }

            setValidationText(resultInfo);
        }
        else
            setValidationText('');
    }
    
    function createSampleTypeList() {
        const st = props.samplePreparationTypes.map(s => s.name);

        setSampleTypes(st);
    }

    function renderSamplePreparationType(e: any) {
        if (e) {
            return (
                <div className="render-preparation-sample-type-container">
                    <div className="render-preparation-sample-type-name">{e.name}</div>
                    <div className="render-search-item-description">{e.description}</div>
                </div>
            );
        }
    }

    function onApplyClick() {
        if (props.onApplySelection)
            props.onApplySelection(sampleName);
    }

    function onCancelClick() {
        if (props.onCancel)
            props.onCancel();
    }
}